import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import {
  useUser,
  fetchWithAuth,
  fetchWithAuthUpload,
} from "../../Context/UserContext";
import { useCompany } from "../../Context/CompanyContext";
import PageLayout from "../../components/layout/PageLayout";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { LoadingOverlay } from "../../components/ui/loading-overlay";
import { useNavigate } from "react-router-dom";
import AccionesPregunta from "../AdminLicitacion/Botones/AccionesPregunta"; // Importar AccionesPregunta
import API_URL from "../../config";
import ModalPreguntar from "../BuscadorLicitaciones/Postular/ModalPreguntar"; // Importar ModalPreguntar
import ModalPostular1 from "../BuscadorLicitaciones/Postular/ModalPostular1"; // Importar ModalPostular1
import ModalPostular2 from "../BuscadorLicitaciones/Postular/ModalPostular2"; // Importar ModalPostular2
import { Helmet } from "react-helmet-async";
import { Share2, FileText } from "lucide-react";
import { Button } from "../../components/ui/button";
import { toast } from "sonner";

import Contacto from "../../Contacto/Contacto"; // Importar Contacto
import EliminarActivar from "../AdminLicitacion/Botones/EliminarActivar"; // Importar modal de eliminar/activar
import InvitarProveedorModal from "./InvitarProveedorModal";

const LicitacionEspecifica = () => {
  const { id } = useParams(); // Parámetros de la URL
  const [tender, setTender] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isOwner, setIsOwner] = useState(false);
  const { user } = useUser();
  const { companies } = useCompany();
  const navigate = useNavigate();

  const [showPreguntarModal, setShowPreguntarModal] = useState(false);
  const [showModal1, setShowModal1] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false); // Estado para mostrar modal

  // Licitación de empresa: gobierna el rol actual (no basta con haberla creado).
  // Licitación personal (sin empresa): solo su creador la gestiona.
  const canManage = tender?.id_company
    ? companies?.company?.id_company === tender.id_company &&
      ["Administrador", "Comprador"].includes(companies?.company?.tipo_cuenta)
    : isOwner;

  const [formData, setFormData] = useState({
    propuesta: "",
    archivosAdjuntos: [],
    adjuntosPreguntas: {},
    respuestas: {},
  });

  useEffect(() => {
    const fetchTender = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(`${API_URL}/licit/get_tender/${id}`);
        if (response.ok) {
          const data = await response.json();
          setTender(data.tender);
          setIsOwner(user && data.tender.id_user === user?.user?.id_user);
        } else {
          console.error("Error al obtener la licitación", response.statusText);
        }
      } catch (error) {
        console.error("Error al obtener la licitación", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchTender();
  }, []);

  const handleOpenModal1 = () => setShowModal1(true);
  const handleCloseModal1 = () => setShowModal1(false);
  const handleCloseModal2 = () => setShowModal2(false);
  const handleClosePreguntarModal = () => setShowPreguntarModal(false);
  const handleCloseShareModal = () => setShowShareModal(false);

  // Función para abrir el modal de eliminar/reactivar
  const handleOpenDeleteModal = () => {
    setShowDeleteModal(true);
  };

  // Función para cerrar el modal de eliminar/reactivar
  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const handleOpenPreguntarModal = () => {
    if (user) {
      setShowPreguntarModal(true);
    } else {
      toast.error("Debes iniciar sesión para preguntar.");
      navigate("/login"); // Redirige al login si no está logueado
    }
  };

  const handleNextFromModal1 = () => {
    setFormData((prev) => ({
      ...prev,
      propuesta: formData.propuesta || prev.propuesta,
      archivosAdjuntos: [...new Set([...(formData.archivosAdjuntos || [])])],
    }));
    setShowModal1(false);
    setShowModal2(true);
  };

  const onBack = () => {
    setFormData((prev) => ({
      ...prev,
      respuestas: { ...prev.respuestas, ...formData.respuestas },
      adjuntosPreguntas: {
        ...prev.adjuntosPreguntas,
        ...formData.adjuntosPreguntas,
      },
    }));
    setShowModal2(false);
    setShowModal1(true);
  };

  const handleSubmitPostulation = async () => {
    setIsLoading(true);
    const id_tender = tender.id_tender;

    const payload = {
      ...formData,
      tender_id: id_tender,
    };

    try {
      const response = await fetchWithAuth(
        `${API_URL}/licit/create_application`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error("Error al crear la postulación");
      }

      const postulationData = await response.json();
      const id_application = postulationData?.id_application;

      if (!id_application) {
        throw new Error("No se recibió un ID de postulación válido.");
      }

      if (formData.archivosAdjuntos?.length > 0) {
        await Promise.all(
          formData.archivosAdjuntos.map(async (file) => {
            if (!(file instanceof File)) return null;

            const fileData = new FormData();
            fileData.append("file", file);
            fileData.append("id_tender", id_tender);
            fileData.append("id_application", id_application);

            const uploadResponse = await fetchWithAuthUpload(
              `${API_URL}/upload/upload-application-file`,
              { method: "POST", body: fileData }
            );

            if (!uploadResponse.ok) {
              console.error(
                `❌ Error al subir archivo:`,
                await uploadResponse.text()
              );
              throw new Error("Error al subir archivo");
            }
          })
        );
      }

      if (Object.keys(formData.adjuntosPreguntas || {}).length > 0) {
        await Promise.all(
          Object.entries(formData.adjuntosPreguntas).map(
            async ([pregunta, data]) => {
              const archivos = data.archivos || [];
              await Promise.all(
                archivos.map(async (file) => {
                  if (!(file instanceof File)) return null;

                  const fileData = new FormData();
                  fileData.append("file", file);
                  fileData.append("id_tender", id_tender);
                  fileData.append("id_application", id_application);
                  fileData.append("id_pregunta", pregunta);

                  const uploadResponse = await fetchWithAuthUpload(
                    `${API_URL}/upload/upload-question-file`,
                    { method: "POST", body: fileData }
                  );

                  if (!uploadResponse.ok) {
                    console.error(
                      `❌ Error al subir archivo de pregunta:`,
                      await uploadResponse.text()
                    );
                    throw new Error("Error al subir archivo de pregunta");
                  }
                })
              );
            }
          )
        );
      }

      toast.success("Postulación enviada con éxito");

      if (companies?.company && !companies.profile?.descripcion) {
        toast.info("Completa el perfil de tu empresa para que más compradores te encuentren", {
          action: {
            label: "Completar perfil",
            onClick: () =>
              navigate(
                `/company-profile/${companies.company.id_company}/admin/descripcion`
              ),
          },
        });
      }

      setShowModal2(false);
      navigate("/mis-postulaciones");
    } catch (error) {
      console.error("Error al enviar la postulación:", error);
      toast.error("Error al enviar la postulación");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmitQuestion = async (question) => {
    setIsLoading(true);
    try {
      const response = await fetchWithAuth(
        `${API_URL}/licit/add_question/${tender.id_tender}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ question }),
        }
      );

      if (response.ok) {
        const { question: newQuestion } = await response.json();
        setTender((prevTender) => ({
          ...prevTender,
          questions: [...(prevTender.questions || []), newQuestion],
        }));
        toast.success("Pregunta añadida correctamente.");
      } else {
        toast.error("Error al enviar la pregunta.");
      }
    } catch (error) {
      console.error("Error al enviar la pregunta:", error.message);
      toast.error("Ocurrió un error al enviar la pregunta.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteQuestionFromBackend = async (id_qa) => {
    setIsLoading(true);
    try {
      const response = await fetchWithAuth(
        `${API_URL}/licit/delete_question/${id_qa}`,
        {
          method: "DELETE",
        }
      );

      if (response.ok) {
        setTender((prevTender) => ({
          ...prevTender,
          questions: prevTender.questions.filter((q) => q.id_qa !== id_qa),
        }));
        toast.success("Pregunta eliminada correctamente.");
      } else {
        toast.error("Error al eliminar la pregunta.");
      }
    } catch (error) {
      console.error("Error al eliminar la pregunta:", error.message);
      toast.error("Ocurrió un error al eliminar la pregunta.");
    } finally {
      setIsLoading(false);
    }
  };

  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return format(date, "PPPP p", { locale: es });
    } catch {
      return "Fecha inválida";
    }
  };

  const handleDeleteQuestion = (id_qa) => {
    handleDeleteQuestionFromBackend(id_qa); // Llama a la API y actualiza el estado local
  };

  const handleReplySuccess = (updatedQuestion) => {
    setTender((prevTender) => ({
      ...prevTender,
      questions: prevTender.questions.map((q) =>
        q.id_qa === updatedQuestion.id_qa ? updatedQuestion : q
      ),
    }));
  };

  if (isLoading) {
    return <LoadingOverlay />;
  }

  if (!tender) {
    return (
      <PageLayout>
        <div className="mx-auto max-w-3xl px-4 py-16 text-center text-destructive">
          No se encontró la licitación
        </div>
      </PageLayout>
    );
  }

  const downloadFile = async (fileId) => {
    try {
      // ✅ Hacer la solicitud para obtener la URL de descarga usando fetchWithAuthUpload
      const response = await fetchWithAuthUpload(
        `${API_URL}/upload/download-file/${fileId}`,
        {
          method: "GET",
        }
      );

      if (!response.ok) {
        throw new Error("Error al obtener el archivo");
      }

      const data = await response.json();

      // ✅ Abrir la URL presignada en una nueva pestaña
      window.open(data.file_url, "_blank");
    } catch (error) {
      console.error("Error al descargar archivo:", error);
    }
  };

  const handleViewApplications = () =>
    navigate(`/ver-postulaciones/${tender.id_tender}`);
  const handleEdit = (id) => {
    if (tender.applications_count > 0) {
      toast.warning(
        "No se puede editar la licitación una vez que ha empezado a recibir propuestas."
      );
    } else {
      navigate(`/editar-licitacion/${id}`);
    }
  };
  const handleReuse = () => navigate(`/reusar-licitacion/${tender.id_tender}`);

  const pageTitle = tender?.titulo
    ? `${tender.titulo} - Licitación en Procu`
    : "Licitación en Procu";
  const pageDescription = tender?.descripcion
    ? tender.descripcion
    : "Consulta los detalles de esta licitación en Procu y encuentra oportunidades de negocio.";
  const pageUrl = `${window.location.origin}/ver-licitacion/${id}/procu`;
  const pageImage = `${window.location.origin}/fotos/logo_black.png`;

  return (
    <PageLayout>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta
          name="keywords"
          content="licitaciones, proveedores, negocios, contratos, oportunidades, Procu, B2B"
        />

        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={pageImage} />
        <meta property="og:type" content="website" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <meta name="twitter:image" content={pageImage} />
      </Helmet>

      {isLoading ? <LoadingOverlay /> : null}

      <div className="mx-auto max-w-3xl space-y-6 px-4 py-8 sm:px-6">
        <div className="space-y-2 rounded-lg border border-border p-6">
          <h1 className="text-2xl font-semibold text-foreground">{tender.titulo}</h1>
          <p className="text-sm text-muted-foreground">
            <strong className="text-foreground">Nº de Licitación:</strong> {tender.id_tender}
          </p>
          <p className="text-sm text-muted-foreground">
            <strong className="text-foreground">Categoría:</strong> {tender.categoria}
          </p>
          {/* Renderizar solo si company_name no es null */}
          {tender.company_name && (
            <p className="text-sm text-muted-foreground">
              <strong className="text-foreground">Empresa:</strong>{" "}
              <a
                href={`/company-profile/${tender.id_company}/${encodeURIComponent(tender.company_name)}`}
                className="text-primary hover:underline"
              >
                {tender.company_name}
              </a>
            </p>
          )}

          {/* Renderizar solo si user_name y user_lastname no son null */}
          {tender.user_name && tender.user_lastname && (
            <p className="text-sm text-muted-foreground">
              <strong className="text-foreground">Creador de la licitación:</strong>{" "}
              <a
                href={`/profile/${tender.id_user}/${encodeURIComponent(
                  `${tender.user_name} ${tender.user_lastname}`
                )}`}
                className="text-primary hover:underline"
              >
                {tender.user_name} {tender.user_lastname}
              </a>
            </p>
          )}
          <p className="text-sm text-muted-foreground">
            <strong className="text-foreground">Creado:</strong> {formatDate(tender.created_at)}
          </p>
          <p className="text-sm text-muted-foreground">
            <strong className="text-foreground">Fecha máx de postulación:</strong>{" "}
            {formatDate(tender.fecha_maxima_postulacion)}
          </p>

          <div className="flex flex-wrap items-center gap-2 pt-3">
            {!user ? (
              <p className="text-sm text-muted-foreground">
                <a href="/register" className="text-primary hover:underline">
                  Regístrate
                </a>{" "}
                o
                <a href="/login" className="text-primary hover:underline">
                  {" "}
                  inicia sesión{" "}
                </a>
                para interactuar con esta licitación.
              </p>
            ) : !canManage ? (
              <>
                {new Date(tender.fecha_maxima_postulacion) >= new Date() && (
                  <Button onClick={handleOpenModal1}>Postular</Button>
                )}
                <Button variant="outline" onClick={handleOpenPreguntarModal}>
                  Preguntar
                </Button>
                <Button variant="ghost" onClick={() => setShowShareModal(true)}>
                  <Share2 className="h-4 w-4" /> Compartir
                </Button>
              </>
            ) : (
              <>
                <Button variant="outline" onClick={handleViewApplications}>
                  Ver Postulaciones
                </Button>
                <Button variant="outline" onClick={handleReuse}>
                  Reusar
                </Button>
                {tender.estado === "Activo" && (
                  <Button variant="outline" onClick={handleEdit}>
                    Editar
                  </Button>
                )}
                <Button
                  variant={tender.estado === "Activo" ? "destructive" : "default"}
                  onClick={handleOpenDeleteModal}
                >
                  {tender.estado === "Activo" ? "Eliminar" : "Reactivar"}
                </Button>
                <Button variant="ghost" onClick={() => setShowShareModal(true)}>
                  <Share2 className="h-4 w-4" /> Compartir
                </Button>
                {tender.estado === "Activo" && (
                  <Button variant="outline" onClick={() => setShowInviteModal(true)}>
                    Invitar proveedor
                  </Button>
                )}
              </>
            )}
          </div>
        </div>

        <div className="space-y-2 rounded-lg border border-border p-6">
          <h3 className="font-semibold text-foreground">Información extra:</h3>
          <p className="text-sm text-muted-foreground">
            <strong className="text-foreground">Descripción:</strong>{" "}
            <span
              dangerouslySetInnerHTML={{
                __html: (tender.descripcion || "").replace(/\n/g, "<br>"),
              }}
            />
          </p>
          {/* Archivos Adjuntos debajo de la Descripción */}
          {tender.files?.length > 0 && (
            <div>
              <h4 className="text-sm font-semibold text-foreground">Archivos adjuntos:</h4>
              <ul className="mt-1 space-y-1">
                {tender.files.map((file, index) => (
                  <li key={index}>
                    <button
                      onClick={() => downloadFile(file.id_file)}
                      className="flex items-center gap-1.5 text-sm text-primary hover:underline"
                    >
                      <FileText className="h-4 w-4" /> {file.file_name || `Archivo ${index + 1}`}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}

          <p className="text-sm text-muted-foreground">
            <strong className="text-foreground">Ciudades del Servicio:</strong>{" "}
            {Array.isArray(tender.ciudad) && tender.ciudad.length > 0
              ? tender.ciudad.join(", ")
              : "No especificado"}
          </p>
          <p className="text-sm text-muted-foreground">
            <strong className="text-foreground">Condiciones de Pago:</strong>{" "}
            {Array.isArray(tender.condiciones_pago) && tender.condiciones_pago.length > 0
              ? tender.condiciones_pago.join(", ")
              : "No especificado"}
          </p>
          <p className="text-sm text-muted-foreground">
            <strong className="text-foreground">Duración del Contrato:</strong>{" "}
            {Array.isArray(tender.duracion_contrato) && tender.duracion_contrato.length > 0
              ? tender.duracion_contrato.join(", ")
              : "No especificado"}
          </p>
        </div>

        <div className="space-y-4 rounded-lg border border-border p-6">
          <h3 className="font-semibold text-foreground">Preguntas y Respuestas</h3>
          {tender.questions && tender.questions.length > 0 ? (
            tender.questions.map((qa) => (
              <div key={qa.id_qa} className="rounded-md border border-border p-3 text-sm">
                <p>
                  <strong className="text-foreground">Usuario:</strong>{" "}
                  <Link
                    to={`/profile/${qa.id_user}/${qa.nombre_usuario}-${qa.apellido_usuario}`}
                    className="text-primary hover:underline"
                  >
                    {qa.nombre_usuario} {qa.apellido_usuario}
                  </Link>
                </p>
                <p className="mt-1">
                  <strong className="text-foreground">Pregunta:</strong> {qa.pregunta}
                </p>
                <p className="mt-1">
                  <strong className="text-foreground">Respuesta:</strong> {qa.respuesta || "Sin respuesta"}
                </p>
                {canManage && (
                  <AccionesPregunta
                    pregunta={qa}
                    onDelete={handleDeleteQuestion}
                    onReplySuccess={handleReplySuccess}
                  />
                )}
              </div>
            ))
          ) : (
            <p className="text-sm text-muted-foreground">No hay preguntas asociadas a esta licitación.</p>
          )}
        </div>
      </div>

      {/* Modal Preguntar */}
      {showPreguntarModal && (
        <ModalPreguntar
          show={showPreguntarModal}
          onClose={handleClosePreguntarModal}
          onSubmit={handleSubmitQuestion}
          tender={tender}
        />
      )}

      {/* Modal Paso 1 - Postulación */}
      {showModal1 && (
        <ModalPostular1
          show={showModal1}
          onClose={handleCloseModal1}
          onNext={handleNextFromModal1}
          tender={tender}
          formData={formData}
          setFormData={setFormData}
        />
      )}

      {/* Modal Paso 2 - Confirmación de respuestas */}
      {showModal2 && (
        <ModalPostular2
          show={showModal2}
          onBack={onBack}
          onClose={handleCloseModal2}
          onSubmit={handleSubmitPostulation}
          tender={tender}
          formData={formData}
          setFormData={setFormData}
        />
      )}

      {/* Modal Compartir */}
      <Contacto
        isOpen={showShareModal}
        onClose={handleCloseShareModal}
        id={tender?.id_tender}
        titulo={tender?.titulo}
      />

      {/* Modal Invitar proveedor */}
      <InvitarProveedorModal
        show={showInviteModal}
        onClose={() => setShowInviteModal(false)}
        tenderId={tender?.id_tender}
      />

      {/* Modal para eliminar/reactivar */}
      {showDeleteModal && (
        <EliminarActivar
          isOpen={showDeleteModal}
          onClose={handleCloseDeleteModal}
          idTender={tender.id_tender}
          estado={tender.estado}
          setSelectedTender={setTender} // Para actualizar el estado en frontend
        />
      )}
    </PageLayout>
  );
};

export default LicitacionEspecifica;
